import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DixuApp from "../components/DixuApp/DixuApp";
import DixuHead from "../components/DixuHead/DixuHead";
import DixuSiteFrame from "../components/DixuSiteFrame/DixuSiteFrame";
import useStickyScrollPosition from "../hooks/useStickyScrollPosition";
import Router from 'next/router';
import NProgress from 'nprogress';
import React from 'react';
import { getUser, redirect } from "../services/ApiService";
import { pathsRequiringLogin } from "../utils/DixuConstants";
import { currentRouteMatches, getReferrerPath, toQueryString } from "../utils/RouterUtils";
import { appWithTranslation } from "../i18n";
import "../styles/_index.scss";
import { ConfigProvider } from 'antd';
import theme from "../SystemTheme";
import { px2remTransformer, StyleProvider } from '@ant-design/cssinjs';
import Script from 'next/script';
NProgress.configure({
  template: `
        <div class="dixu-page-load-indicator dixu-page-load-indicator--bar" role="bar">
            <div class="dixu-page-load-indicator__peg"></div>
        </div>
        <div class="dixu-page-load-indicator dixu-page-load-indicator--spinner" role="spinner">
            <div class="dixu-page-load-indicator__spinner-icon"></div>
        </div>
    `
});
let pageLoadIndicatorTimeoutIDs = [];
Router.events.on('routeChangeStart', () => {
  pageLoadIndicatorTimeoutIDs.push(setTimeout(() => {
    NProgress.start();
  }, 1000));
});
Router.events.on('routeChangeComplete', () => {
  NProgress.done();
  pageLoadIndicatorTimeoutIDs.forEach(id => window.clearTimeout(id));
  pageLoadIndicatorTimeoutIDs = [];
});
Router.events.on('routeChangeError', () => {
  NProgress.done();
  pageLoadIndicatorTimeoutIDs.forEach(id => window.clearTimeout(id));
  pageLoadIndicatorTimeoutIDs = [];
});
useStickyScrollPosition.initialize();
const pathProps = {
  '/': {
    siteFrameProps: {
      mainNavProps: {
        position: 'fixed',
        colorScheme: 'dark',
        solid: false
      }
    }
  },
  '/myy-asuntosi': {
    siteFrameProps: {
      mainNavProps: {
        position: 'fixed',
        colorScheme: 'dark',
        solid: false
      }
    }
  },
  '/myytavat-asunnot/asunto/[address]/[id]': {
    siteFrameProps: {
      mainNavProps: {
        colorScheme: 'dark',
        translucent: false,
        autoHide: false,
        position: 'static'
      }
    }
  },
  '/rekisteroidy*': {
    siteFrameProps: {
      hideMainNav: true,
      hideMainFooter: true
    }
  },
  '/myy-asuntosi/aloita-myynti*': {
    siteFrameProps: {
      hideMainNav: true,
      hideMainFooter: true
    }
  },
  '/oma-dixu*': {
    siteFrameProps: {
      mainNavProps: {
        colorScheme: 'dark',
        translucent: false,
        autoHide: false,
        position: 'static'
      },
      hideMainFooter: true
    }
  },
  '/tarjouskauppa/*': {
    siteFrameProps: {
      hideMainNav: true,
      hideMainFooter: true
    }
  }
};
const MyApp = _ref => {
  let {
    Component,
    pageProps
  } = _ref;
  const {
    user
  } = pageProps;
  const px2rem = px2remTransformer({
    rootValue: 14
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, user && /*#__PURE__*/React.createElement(Script, {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: `window.__USER = ${JSON.stringify(user)}`
    }
  }), /*#__PURE__*/React.createElement(DixuHead, {
    title: "Dixusta koti",
    description: "Dixu on nyt my\xF6s markkinapaikka, josta l\xF6yd\xE4t Dixu-kohteiden lis\xE4ksi kiinteist\xF6nv\xE4litt\xE4jien omia kohteita. Valitse hakuehdot ja l\xF6yd\xE4 unelmiesi koti!",
    image: "/images/meta.jpg",
    root: true
  }), /*#__PURE__*/React.createElement(StyleProvider, {
    transformers: [px2rem]
  }, /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: _objectSpread({}, theme)
  }, /*#__PURE__*/React.createElement(DixuApp, {
    user: user
  }, /*#__PURE__*/React.createElement(DixuSiteFrame, pageProps.siteFrameProps, /*#__PURE__*/React.createElement(Component, pageProps))))));
};
MyApp.getInitialProps = async _ref2 => {
  let {
    Component,
    ctx
  } = _ref2;
  const {
    pathname,
    req,
    res
  } = ctx;
  const user = getUser({
    req
  });
  if (!user) {
    if (currentRouteMatches(pathsRequiringLogin, {
      pathname
    })) {
      redirect(`/rekisteroidy${toQueryString({
        referrerPath: getReferrerPath({
          req
        })
      })}`, {
        res
      });
    }
  }
  const activePathProps = (() => {
    return Object.entries(pathProps).find(_ref3 => {
      let [path] = _ref3;
      return currentRouteMatches([path], {
        pathname
      });
    })?.[1];
  })();
  const pageProps = _objectSpread(_objectSpread(_objectSpread({}, await Component?.getInitialProps?.(ctx)), activePathProps), {}, {
    user
  });
  return {
    pageProps
  };
};
export default appWithTranslation(MyApp);